import React, { useEffect } from "react";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Privacy Policy</h1>
      <div className={styles.content}>
        <section>
          <h2 className={styles.sectionTitle}>1. Information We Collect</h2>
          <p className={styles.paragraph}>
            We collect information that you provide directly to us, including:
          </p>
          <ul className={styles.list}>
            <li>Name and contact information</li>
            <li>Business information</li>
            <li>Payment information</li>
            <li>Communications you send to us</li>
          </ul>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>
            2. How We Use Your Information
          </h2>
          <p className={styles.paragraph}>
            We use the information we collect to:
          </p>
          <ul className={styles.list}>
            <li>Provide and maintain our services</li>
            <li>Process your transactions</li>
            <li>Send you marketing communications (with your consent)</li>
            <li>Improve our services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>3. Data Security</h2>
          <p className={styles.paragraph}>
            We implement appropriate security measures to protect your personal
            information. However, no method of transmission over the Internet is
            100% secure. Our security measures include:
          </p>
          <ul className={styles.list}>
            <li>Encryption of data in transit using SSL/TLS protocols</li>
            <li>Regular security assessments and penetration testing</li>
            <li>Access controls and authentication mechanisms</li>
            <li>Secure data backups and disaster recovery plans</li>
            <li>Regular security training for our employees</li>
          </ul>
          <p className={styles.paragraph}>
            We regularly review and update our security practices to ensure the
            ongoing confidentiality, integrity, and availability of your data.
            In the event of a data breach, we will promptly notify affected
            users and take appropriate measures to address the incident.
          </p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>4. Third-Party Services</h2>
          <p className={styles.paragraph}>
            We may employ third-party companies and individuals to facilitate
            our service, including:
          </p>
          <ul className={styles.list}>
            <li>Payment processors</li>
            <li>Analytics providers</li>
            <li>Cloud storage providers</li>
            <li>Customer support services</li>
          </ul>
          <p className={styles.paragraph}>
            These third parties have access to your personal data only to
            perform specific tasks on our behalf and are obligated to protect
            your information.
          </p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>5. Cookies and Tracking</h2>
          <p className={styles.paragraph}>
            We use cookies and similar tracking technologies to track activity
            on our service and hold certain information.
          </p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>6. Your Rights</h2>
          <p className={styles.paragraph}>You have the right to:</p>
          <ul className={styles.list}>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to our use of your data</li>
            <li>Request data portability</li>
          </ul>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>7. Contact Us</h2>
          <p className={styles.paragraph}>
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p className={styles.paragraph}>Email: privacy@yourcompany.com</p>
          <p className={styles.paragraph}>Address: [Your Company Address]</p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>8. Updates to This Policy</h2>
          <p className={styles.paragraph}>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last Updated" date.
          </p>
          <p className={styles.lastUpdated}>
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
